import {
  Button,
  DialogContent,
  DialogActions,
  TextField,
  CircularProgress,
  Grid
} from '@material-ui/core';
import React, { useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import {
  createRouteCategoryAction,
  updateRouteCategoryAction
} from 'src/store/actions/RouteCategoryActions';

function RouteCategoryManager({ handleClose, modalData }) {
  const profile = JSON.parse(sessionStorage.getItem('profile'));
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleSubmitAction = async (values) => {
    setLoading(true);
    const response = !modalData
      ? await dispatch(createRouteCategoryAction(values, profile))
      : await dispatch(
          updateRouteCategoryAction(modalData.id, values, profile)
        );
    setLoading(false);
    if (response.status === 1) handleClose();
  };

  return (
    <Formik
      initialValues={{
        name: `${modalData?.name || ''}`
      }}
      validationSchema={Yup.object().shape({
        name: Yup.string().trim().max(255)
      })}
      onSubmit={(values) => {
        handleSubmitAction(values);
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        touched,
        values,
        setFieldValue
      }) => (
        <form onSubmit={handleSubmit}>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs="12">
                <TextField
                  error={Boolean(touched.name && errors.name)}
                  fullWidth
                  helperText={touched.name && errors.name}
                  label="Name"
                  margin="dense"
                  name="name"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="text"
                  value={values.name}
                  variant="outlined"
                  size="small"
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" onClick={handleClose}>
              Close
            </Button>
            <Button
              disabled={loading}
              variant="contained"
              color="primary"
              type="submit"
            >
              {loading && <CircularProgress size="1.5rem" />}
              Submit
            </Button>
          </DialogActions>
        </form>
      )}
    </Formik>
  );
}

export default RouteCategoryManager;
